var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Moveable",
    _vm._b(
      {
        ref: "handler",
        staticClass: "draggable-signature",
        style: _vm.style,
        on: { drag: _vm.handleDrag, "drag-end": _vm.handleDragEnd }
      },
      "Moveable",
      _vm.moveable,
      false
    ),
    [
      _c("Signature", {
        attrs: { name: _vm.name, closable: _vm.closable },
        on: {
          close: function($event) {
            return _vm.$emit("close")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }